import React from 'react';
import { Box, Chip, IconButton, Tooltip } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import StorageIcon from '@material-ui/icons/Storage';
import FolderIcon from '@material-ui/icons/Folder';

interface KubernetesHeaderProps {
  clusterName: string;
  namespace: string;
  workloadName: string;
  onRefresh: () => void;
  loading?: boolean;
  podOverview?: { running: number; total: number };
}

export const KubernetesHeader: React.FC<KubernetesHeaderProps> = ({
  clusterName,
  namespace,
  workloadName,
  onRefresh,
  loading,
  podOverview,
}) => {
  const allRunning = podOverview
    ? podOverview.running === podOverview.total && podOverview.total > 0
    : false;

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      style={{ gap: 8, marginBottom: 16, padding: '8px 0' }}
    >
      <Chip
        icon={<StorageIcon style={{ fontSize: '0.85rem' }} />}
        label={clusterName || 'unknown'}
        size="small"
        variant="outlined"
      />
      <Chip
        icon={<FolderIcon style={{ fontSize: '0.85rem' }} />}
        label={namespace}
        size="small"
        variant="outlined"
      />
      <Chip
        label={workloadName}
        size="small"
        color="primary"
        variant="outlined"
      />
      {podOverview !== undefined && (
        <Chip
          label={`Pod ${podOverview.running}/${podOverview.total}`}
          size="small"
          style={{
            backgroundColor: allRunning ? '#e8f5e9' : '#fff8e1',
            color: allRunning ? '#2e7d32' : '#e65100',
            border: `1px solid ${allRunning ? '#a5d6a7' : '#ffcc80'}`,
            fontWeight: 600,
          }}
        />
      )}
      <Box flexGrow={1} />
      <Tooltip title="刷新">
        <span>
          <IconButton size="small" onClick={onRefresh} disabled={loading}>
            <RefreshIcon
              fontSize="small"
              style={{ animation: loading ? 'spin 1s linear infinite' : 'none' }}
            />
          </IconButton>
        </span>
      </Tooltip>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </Box>
  );
};
